export const page_left_gutter: string = "110px";
export const page_right_gutter: string = "70px";
export const page_top_gutter: string = "85px";
export const page_bottom_gutter: string = "20px";
